import type MenuI from '@/types/Navigation/MenuI'
import type MenuItemI from '@/types/Navigation/MenuItemI'
import fetchGql from '@/utils/fetchGql'
import { useCacheStorage } from '@/composables/useSessionStorage'
import getInvestorMenuItems from '@/gql/getInvestorMenuItems.gql'

const { getCache } = useCacheStorage()

const getMenuData = (item: MenuItemI, locale: string) => {
  const data = {
    title: item.title,
    key: formatSbPath(item.redirect?.story?.full_slug, locale) || '/',
    enData: {
      name: item.redirect?.story?.name || '',
      slug: item.redirect?.story?.slug || ''
    }
  }

  return data
}

const parseData = (data: any, locale: string) => {
  const result: MenuI[] = []

  data[0].content.items.forEach((menuItem: MenuItemI) => {
    if (menuItem.subItems?.length) {
      const parsedItems: MenuI[] = []
      menuItem.subItems.forEach((item: MenuItemI) => {
        parsedItems.push({
          ...getMenuData(item, locale)
        })
      })
      result.push({
        ...getMenuData(menuItem, locale),
        subItems: parsedItems
      })
    } else {
      result.push({
        ...getMenuData(menuItem, locale)
      })
    }
  })

  return result
}

export const useFetchMenu = () => {
  const fetchMenu = (language: string) => {
    const cache = getCache(`investors-menu-${language}`)

    const variables = {
      language: language === 'en' ? '' : `${language}/*`
    }

    if (cache.value.data) return cache.value.data

    return fetchGql(getInvestorMenuItems, variables).then((response: any) => {
      return (cache.value.data = parseData(response.MenuItems.items, variables.language))
    })
  }

  return { fetchMenu }
}
